module.exports = __webpack_public_path__ + "static/img/star-year-no3.2af28a43.png";